// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__22NPx","modalForm":"UpgradeEpcsModal_modalForm__1mwHY","modalFooter":"UpgradeEpcsModal_modalFooter__2Mv-d"};